
import { defineComponent } from "vue";

import ReloadWindow from "@/components/ReloadWindow.vue";
import ScrollToTopButton from "@/components/ScrollToTopButton/ScrollToTopButton.vue";
import SiteNavbar from "@/components/Navbar/Navbar.vue";
import SiteFooter from "@/components/Footer/Footer.vue";

export default defineComponent({
  components: { ReloadWindow, ScrollToTopButton, SiteFooter, SiteNavbar },
});
